/**
 * エラー通知機能
 *
 * このMixinが適用されたコンポーネントの`errors`を監視し、変更があった場合
 * `update:errors`でそれをemitします。
 *
 * 使用例）
 * export default {
 *   mixins: [ErrorReport],
 *   // 略
 *   computed: {
 *     errors() { // このcomputedの変更が監視されます
 *       return this.text.length > 10
 *     }
 *   }
 * }
 */
export default {
  watch: {
    errors: {
      immediate: true,
      handler(errors) {
        this.$emit('update:errors', errors)
      },
    },
  },
}
